import { useUserEventLogger } from '@repo/tracking-service';
import { Button, Guide } from '@zenterprise-inc/ui';

import IllustCert from '@/assets/illust-icons/fill-register-cert.svg';

const CorporationJointCertificateGuide = ({ handleClick }: { handleClick: () => void }) => {
  const { sendClickEvent } = useUserEventLogger();
  return (
    <Guide>
      <Guide.ImageArea>
        <IllustCert />
      </Guide.ImageArea>
      <Guide.TextArea>
        <Guide.Title titleType="large" className="text-gray-900">
          공동인증서로 조회하기
        </Guide.Title>
        <Guide.Description className="body-16">
          홈택스에 등록된
          <br />
          공동인증서로 조회해요.
        </Guide.Description>
      </Guide.TextArea>
      <Guide.ButtonArea>
        <Button.Box
          size="large"
          state="primary"
          onClick={() => {
            sendClickEvent(`corps-selectauth_commoncert_large`);
            handleClick();
          }}
        >
          30초 만에 조회하기
        </Button.Box>
      </Guide.ButtonArea>
    </Guide>
  );
};

export default CorporationJointCertificateGuide;
